import { render, staticRenderFns } from "./PlatformConfigModal.vue?vue&type=template&id=1341832a&scoped=true"
import script from "./PlatformConfigModal.vue?vue&type=script&lang=js"
export * from "./PlatformConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1341832a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1341832a')) {
      api.createRecord('1341832a', component.options)
    } else {
      api.reload('1341832a', component.options)
    }
    module.hot.accept("./PlatformConfigModal.vue?vue&type=template&id=1341832a&scoped=true", function () {
      api.rerender('1341832a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/PlatformConfigModal.vue"
export default component.exports